<template>
  <div class="row heading-wrapper">
    <div class="col-md-8 mb-4  mb-lg-0">
      <div :style="`background-image: url(${imageHeadingLeft})`"
           class="heading-image-left d-flex align-items-end">
        <div class="heading-title-container">
          <div class="heading-title">{{ line1 }}</div>
          <div class="heading-title">{{ line2 }}</div>
          <div class="heading-title">{{ line3 }}</div>
          <div class="heading-title">{{ line4 }}</div>
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-4  mb-lg-0">
      <div :style="`background-image: url(${imageHeadingRight})`"
           class=" heading-image-right"></div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'AboutHeadingComponent',
  components: {},
  props: {
    line1: {
      type: String,
    },
    line2: {
      type: String,
    },
    line3: {
      type: String,
    },
    line4: {
      type: String,
    },
    imageHeadingLeft: {
      type: String,
    },
    imageHeadingRight: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.heading-wrapper {
  border-radius: 30px;

  overflow: hidden;


  .heading-title-container {
    padding: 20px;

    .heading-title {
      font-size: $title-h5;
      line-height: 1;
      text-transform: uppercase;
      color: $color-white;
      width: 100%;
      word-break: break-all;
      hyphens: auto;
    }
  }

  .heading-image-left, .heading-image-right {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    border-radius: 30px;
  }

  .heading-image-left {
    min-height: 600px;
  }

  .heading-image-right {
    min-height: 300px;
  }

}

@media screen and (min-width: 768px) {
  .heading-wrapper {

    .heading-image-right {
      min-height: 600px;
    }

    .heading-title-container {
      padding: 50px;

      .heading-title {
        font-size: $title-h3;
        line-height: $title-h3;
      }
    }
  }

}
</style>
